<template>
    <v-container class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12" lg="10">
                <v-card>
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        CREAR TICKET DE SOPORTE
                    </v-card-title>
                    <v-card-subtitle class="text-center mt-4">
                        Selecciona el area correcta para que soporte pueda revisar el caso con la informacion necesaria.
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" lg="10">
                <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1">Area</v-stepper-step>
                        <v-divider/>
                        <v-stepper-step :complete="e1 > 2" step="2">Detalle</v-stepper-step>
                        <v-divider/>
                        <v-stepper-step step="3">Contacto</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                            <v-stepper-content class="px-2 px-md-4" step="1">
                                <v-card class="mb-8" outlined color="transparent">
                                    <v-card-text>
                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <v-select
                                                    :label="labels.country"
                                                    :items="countries"
                                                    name="country"
                                                    v-model="form.country"
                                                    :error-messages="errors.country"
                                                    :disabled="loading"
                                                    :rules="[rules.required('country')]"
                                                    @change="clearErrors('country')"
                                                    prepend-inner-icon="mdi-map-marker"
                                                    item-text="name"
                                                    item-value="code"
                                                    filled>
                                                    <template v-slot:selection="{ item }">
                                                        <v-flex>
                                                            <v-avatar size="28px">
                                                                <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()"/>
                                                            </v-avatar>
                                                            <span class='ml-1'>{{ item.name }}</span>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-avatar>
                                                            <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()"/>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="item.name"/>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-select
                                                    :label="labels.payment"
                                                    :items="modules"
                                                    name="payment"
                                                    v-model="form.payment"
                                                    :error-messages="errors.payment"
                                                    :disabled="loading"
                                                    :rules="[rules.required('payment')]"
                                                    @change="onModuleChange"
                                                    prepend-inner-icon="mdi-shape"
                                                    item-text="text"
                                                    item-value="value"
                                                    filled>
                                                    <template v-slot:selection="{ item }">
                                                        <v-flex>
                                                            <v-avatar size="28px" color="primary">
                                                                <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                            </v-avatar>
                                                            <span class='ml-1'>{{ item.text }}</span>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-avatar color="primary">
                                                            <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="item.text"/>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    :label="referenceLabel"
                                                    v-model="form.reference_id"
                                                    name="reference_id"
                                                    :error-messages="errors.reference_id"
                                                    :disabled="loading"
                                                    :hint="referenceHint"
                                                    :rules="[optionalMinRule(referenceLabel, 3)]"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-pound"
                                                    @input="clearErrors('reference_id')"
                                                    filled/>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-select
                                                    :label="labels.claim"
                                                    :items="previousTicketOptions"
                                                    name="claim"
                                                    v-model="form.claim"
                                                    :error-messages="errors.claim"
                                                    :disabled="loading"
                                                    :rules="[rules.required('claim')]"
                                                    @change="clearErrors('claim')"
                                                    prepend-inner-icon="mdi-history"
                                                    item-text="text"
                                                    item-value="value"
                                                    filled>
                                                    <template v-slot:selection="{ item }">
                                                        <v-flex>
                                                            <v-avatar size="28px" color="primary">
                                                                <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                            </v-avatar>
                                                            <span class='ml-1'>{{ item.text }}</span>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-avatar color="primary">
                                                            <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="item.text"/>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>

                                <v-btn color="tertiary" dark @click="$router.go(-1)">Salir</v-btn>
                                <v-btn class="float-right" color="primary" @click="next(1)">Continuar</v-btn>
                            </v-stepper-content>

                            <v-stepper-content class="px-2 px-md-4" step="2">
                                <v-card class="mb-8" outlined color="transparent">
                                    <v-card-text>
                                        <v-row justify="center">
                                            <v-col cols="12" md="10">
                                                <v-select
                                                    v-if="e1 > 1"
                                                    :label="labels.reason"
                                                    :items="currentReasons"
                                                    name="reason"
                                                    v-model="form.reason"
                                                    :error-messages="errors.reason"
                                                    :disabled="loading"
                                                    :rules="[rules.required('reason')]"
                                                    @change="clearErrors('reason')"
                                                    prepend-inner-icon="mdi-alert-circle"
                                                    item-text="value"
                                                    item-value="value"
                                                    filled>
                                                    <template v-slot:selection="{ item }">
                                                        <v-flex>
                                                            <v-avatar size="28px" color="primary">
                                                                <v-icon class="secondary--text">mdi-check-circle</v-icon>
                                                            </v-avatar>
                                                            <span class='ml-1'>{{ item.value }}</span>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-avatar color="primary">
                                                            <v-icon class="secondary--text">mdi-check-circle</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="item.value"/>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="10">
                                                <v-textarea
                                                    v-if="e1 > 1"
                                                    :label="labels.description"
                                                    v-model="form.description"
                                                    name="description"
                                                    counter="1000"
                                                    :error-messages="errors.description"
                                                    :disabled="loading"
                                                    :rules="[rules.req('description'), rules.min('description', 12, 'La'), rules.max('description', 1000, 'La')]"
                                                    prepend-inner-icon="mdi-clipboard-text"
                                                    @input="clearErrors('description')"
                                                    no-resize
                                                    rows="5"
                                                    filled/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>

                                <v-btn color="tertiary" dark @click="e1 = e1 - 1">Atras</v-btn>
                                <v-btn class="float-right" color="primary" @click="next(2)">Continuar</v-btn>
                            </v-stepper-content>

                            <v-stepper-content class="px-2 px-md-4" step="3">
                                <v-card class="mb-8" outlined color="transparent">
                                    <v-card-text>
                                        <v-row justify="center">
                                            <v-col cols="12" md="6">
                                                <v-select
                                                    v-if="e1 > 2"
                                                    :label="labels.connection"
                                                    :items="relationships"
                                                    name="connection"
                                                    v-model="form.connection"
                                                    :error-messages="errors.connection"
                                                    :disabled="loading"
                                                    :rules="[rules.required('connection')]"
                                                    @change="clearErrors('connection')"
                                                    prepend-inner-icon="mdi-account-circle"
                                                    item-text="value"
                                                    item-value="value"
                                                    filled>
                                                    <template v-slot:selection="{ item }">
                                                        <v-flex>
                                                            <v-avatar size="28px" color="primary">
                                                                <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                            </v-avatar>
                                                            <span class='ml-1'>{{ item.value }}</span>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <v-list-item-avatar color="primary">
                                                            <v-icon class="secondary--text">{{ item.icon }}</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="item.value"/>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    v-if="e1 > 2"
                                                    :label="labels.phone"
                                                    v-model="form.phone"
                                                    type="tel"
                                                    name="phone"
                                                    :error-messages="errors.phone"
                                                    :rules="[rules.required('phone'), rules.min('phone', 8, 'El')]"
                                                    :disabled="loading"
                                                    prepend-inner-icon="mdi-phone"
                                                    @input="clearErrors('phone')"
                                                    v-mask="mask"
                                                    filled/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>

                                <v-btn color="tertiary" dark @click="e1 = e1 - 1">Atras</v-btn>
                                <v-btn class="float-right" color="success" :loading="loading" :disabled="loading" @click="submit">
                                    Enviar ticket
                                </v-btn>
                            </v-stepper-content>
                        </v-form>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../helpers/form";
    import { mask }from 'vue-the-mask';

    export default {
        name: "Claim",
        mixins: [ Form ],
        props: [ 'user' ],
        directives: { mask },
        data: () => ({
            e1:  1,
            countries: [
                { name: 'Venezuela', code: 'VEN' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Peru', code: 'PER' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Europa', code: 'EUR' },
                { name: 'Brasil', code: 'BRA' },
                { name: 'Mexico', code: 'MEX' },
                { name: 'Panama', code: 'PAN' },
                { name: 'Estados Unidos', code: 'USA' }
            ],
            modules: [
                { text: 'Wallet y saldo', value: 'Wallet', icon: 'mdi-wallet', reference: 'ID de movimiento' },
                { text: 'Recarga de wallet', value: 'Recharge', icon: 'mdi-cash-plus', reference: 'ID de recarga' },
                { text: 'Retiro de wallet', value: 'Withdrawal', icon: 'mdi-bank-transfer-out', reference: 'ID de retiro' },
                { text: 'Transferencia o pago QR', value: 'WalletTransfer', icon: 'mdi-send', reference: 'ID de transferencia' },
                { text: 'Envio de remesa', value: 'Remittance', icon: 'mdi-bank-transfer', reference: 'ID de giro' },
                { text: 'Cuentas bancarias', value: 'BankAccount', icon: 'mdi-account-cash', reference: 'ID de cuenta' },
                { text: 'Identidad y documentos', value: 'Identity', icon: 'mdi-card-account-details-star', reference: 'ID de verificacion' },
                { text: 'Recompensas', value: 'Rewards', icon: 'mdi-hand-coin', reference: 'ID de recompensa' },
                { text: 'App, login o notificaciones', value: 'App', icon: 'mdi-cellphone-cog', reference: 'ID de evento' },
                { text: 'Seguridad', value: 'Security', icon: 'mdi-shield-account', reference: 'ID de evento' },
                { text: 'Otro', value: 'Other', icon: 'mdi-help-circle', reference: 'Referencia' }
            ],
            previousTicketOptions: [
                { text: 'No', value: '0', icon: 'mdi-close-circle' },
                { text: 'Si', value: '1', icon: 'mdi-check-circle' }
            ],
            defaultReasons: [
                { value: 'Necesito ayuda para completar una operacion' },
                { value: 'La informacion no aparece correcta' },
                { value: 'Tengo una duda sobre mi cuenta' },
                { value: 'Otro caso' }
            ],
            reasonsByModule: {
                Wallet: [
                    { value: 'Mi saldo no se actualizo' },
                    { value: 'Veo un movimiento que no reconozco' },
                    { value: 'El monto mostrado no coincide' },
                    { value: 'Otro caso de wallet' }
                ],
                Recharge: [
                    { value: 'Mi recarga sigue pendiente' },
                    { value: 'Necesito corregir el comprobante' },
                    { value: 'La conversion o el monto no coincide' },
                    { value: 'Otro caso de recarga' }
                ],
                Withdrawal: [
                    { value: 'Mi retiro sigue pendiente' },
                    { value: 'Necesito cambiar el destino del retiro' },
                    { value: 'El monto o la comision no coincide' },
                    { value: 'Otro caso de retiro' }
                ],
                WalletTransfer: [
                    { value: 'La transferencia o pago QR no se completo' },
                    { value: 'Envié al usuario equivocado' },
                    { value: 'El monto fue descontado y no abonado' },
                    { value: 'Otro caso de transferencia' }
                ],
                Remittance: [
                    { value: 'Mi giro no ha sido realizado' },
                    { value: 'Mi beneficiario no ha recibido' },
                    { value: 'Necesito corregir datos del giro' },
                    { value: 'Otro caso de remesa' }
                ],
                BankAccount: [
                    { value: 'Mi cuenta bancaria no fue aprobada' },
                    { value: 'Necesito actualizar el certificado bancario' },
                    { value: 'La cuenta aprobada no aparece para retiro' },
                    { value: 'Otro caso de cuenta bancaria' }
                ],
                Identity: [
                    { value: 'No puedo validar mi identidad' },
                    { value: 'Mi documento fue rechazado' },
                    { value: 'Necesito validar otro documento propio' },
                    { value: 'Otro caso de identidad' }
                ],
                Rewards: [
                    { value: 'No recibí puntos por un video' },
                    { value: 'No puedo canjear mis puntos' },
                    { value: 'Mi recompensa no aparece' },
                    { value: 'Otro caso de recompensas' }
                ],
                App: [
                    { value: 'No puedo ingresar a mi cuenta' },
                    { value: 'No recibo notificaciones' },
                    { value: 'La app no carga correctamente' },
                    { value: 'Otro caso tecnico' }
                ],
                Security: [
                    { value: 'No reconozco una actividad en mi cuenta' },
                    { value: 'Necesito ayuda con mi clave o acceso' },
                    { value: 'Quiero revisar mis dispositivos' },
                    { value: 'Otro caso de seguridad' }
                ]
            },
            relationships: [
                { value: 'Titular de la cuenta', icon: 'mdi-account-check' },
                { value: 'Remitente', icon: 'mdi-account-arrow-right' },
                { value: 'Beneficiario', icon: 'mdi-account-arrow-left' },
                { value: 'Pagador', icon: 'mdi-cash-check' },
                { value: 'Comercio', icon: 'mdi-storefront' }
            ],
            labels: {
                reference_id: 'Referencia',
                country: 'Pais relacionado',
                payment: 'Area del sistema',
                claim: 'Ya tengo otro ticket por este caso',
                reason: 'Motivo del ticket',
                description: 'Descripcion',
                connection: 'Relacion con el caso',
                phone: 'Numero de telefono/celular'
            },
            form: {
                reference_id: null,
                sid: null,
                tid: null,
                country: null,
                payment: null,
                claim: '0',
                reason: null,
                description: null,
                connection: null,
                phone: null
            },
            mask: '### #######'
        }),
        computed: {
            selectedModule() {
                return this.modules.find(item => item.value === this.form.payment) || null;
            },
            referenceLabel() {
                return (this.selectedModule ? this.selectedModule.reference : 'Referencia') + ' (opcional)';
            },
            referenceHint() {
                if (!this.selectedModule) {
                    return 'Si tienes un ID de operacion, agregalo aqui.';
                }

                return 'Solo si ya tienes ' + this.selectedModule.reference.toLowerCase() + '.';
            },
            currentReasons() {
                return this.reasonsByModule[this.form.payment] || this.defaultReasons;
            }
        },
        watch: {
            'form.country'() {
                this.maskPhone();
            }
        },
        methods: {
            next(code) {
                if (this.$refs.form.validate()) {
                    this.e1 = code + 1;
                }
            },
            onModuleChange() {
                this.clearErrors('payment');
                if (!this.currentReasons.find(item => item.value === this.form.reason)) {
                    this.form.reason = null;
                }
            },
            optionalMinRule(label, num) {
                return (v) => !v || String(v).length >= num || 'El ' + label.toLowerCase() + ' debe tener mas de ' + num + ' caracteres.';
            },
            normalizePayload() {
                const reference = this.form.reference_id ? String(this.form.reference_id).replace(/[^0-9]/g, '') : null;
                const transferModules = ['Withdrawal', 'WalletTransfer', 'Remittance'];
                const payload = Object.assign({}, this.form, {
                    sid: null,
                    tid: null
                });

                if (reference) {
                    if (transferModules.indexOf(this.form.payment) !== -1) {
                        payload.tid = reference;
                    } else {
                        payload.sid = reference;
                    }
                }

                return payload;
            },
            maskPhone() {
                if (this.form.country === 'CHL') {
                    this.mask = '# ## ####-####';
                } else if (this.form.country === 'COL') {
                    this.mask = '### #######';
                } else if (this.form.country === 'ECU') {
                    this.mask = '## ########';
                } else if (this.form.country === 'MEX') {
                    this.mask = '### ### ####';
                } else if (this.form.country === 'PAN') {
                    this.mask = '####-####';
                } else if (this.form.country === 'PER') {
                    this.mask = '### ### ###';
                } else if (this.form.country === 'USA') {
                    this.mask = '(###) ###-####';
                } else if (this.form.country === 'VEN') {
                    this.mask = '####-###-####';
                } else {
                    this.mask = '### #######';
                }
            },
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    axios.post('/api/claim', this.normalizePayload())
                        .then((res) => {
                            this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                            this.$router.push({ name: 'ClaimView', params: { id: res.data.id } });
                        })
                        .catch(err => {
                            if (err.response && err.response.data && err.response.data.errors) {
                                this.handleErrors(err.response.data.errors);
                            } else {
                                this.$toast.error('No fue posible crear el ticket.', { icon: 'mdi-alert-circle' });
                            }
                        })
                        .then(() => {
                            this.loading = false;
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>
